import type { GetBoardInput } from '@/types/generated';

export const queryKeys = {
  board: {
    all: () => ['board'] as const,
    detail: (params: Partial<GetBoardInput>) =>
      ['board', 'detail', params] as const,
  },
  task: {
    detail: (id: string) => ['task', 'detail', id] as const,
  },
  comments: {
    forTask: (taskId: string) => ['comments', taskId] as const,
    page: (taskId: string, offset: number) =>
      ['comments', taskId, 'page', offset] as const,
  },
  taskAssignments: {
    forTask: (id: string) => ['task_assignments', id] as const,
  },
  taskRelations: {
    all: () => ['task_relations'] as const,
    forTask: (id: string) => ['task_relations', id] as const,
  },
  orgUsers: {
    all: () => ['org_users'] as const,
    forOrg: (orgId: string) => ['org_users', orgId] as const,
  },
  allOrgs: {
    all: () => ['all_orgs'] as const,
  },
  orgConfigurations: {
    all: () => ['org_configurations'] as const,
    forOrg: (orgId: string) => ['org_configurations', orgId] as const,
  },
  boardPreferences: {
    all: () => ['board_preferences'] as const,
    forBoard: (id: string) => ['board_preferences', id] as const,
  },
  dashboardStats: {
    forUser: (userId: string, orgId: string | undefined) =>
      ['dashboard_stats', userId, orgId] as const,
  },
  notifications: {
    forUser: (userId: string) => ['notifications', userId] as const,
  },
  boardTemplates: {
    all: () => ['board_templates'] as const,
    forOrg: (orgId: string) => ['board_templates', orgId] as const,
  },
  userPreferences: {
    all: () => ['user_preferences'] as const,
  },
  learningProgressStats: {
    forUser: (userId: string, orgId: string | undefined, role?: string) =>
      ['learning_progress_stats', userId, orgId, role] as const,
  },
  myProgress: {
    forUser: (userId: string, orgId: string | undefined, role?: string) =>
      ['my_progress', userId, orgId, role] as const,
  },
  userGroups: {
    all: () => ['user_groups'] as const,
    forOrg: (orgId: string) => ['user_groups', orgId] as const,
  },
  cohortBoard: {
    forGroup: (groupId: string, orgId: string) =>
      ['cohort_board', groupId, orgId] as const,
  },
  scheduledJobs: {
    all: () => ['scheduled_jobs'] as const,
    forOrg: (orgId: string) => ['scheduled_jobs', orgId] as const,
  },
  jobRuns: {
    forJob: (jobId: string) => ['job_runs', jobId] as const,
  },
  userGroupMembers: {
    forGroup: (groupId: string) => ['user_group_members', groupId] as const,
    forGroups: (groupIds: string[]) =>
      ['user_group_members', 'bulk', [...groupIds].sort()] as const,
  },
  userProfile: {
    forUser: (userId: string, orgId: string | undefined) =>
      ['user_profile', userId, orgId] as const,
  },
  profilePictures: {
    all: () => ['profile_pictures'] as const,
  },
  boardBackgrounds: {
    forBoard: (boardId: string) => ['board_backgrounds', boardId] as const,
  },
  orgProfilePictures: {
    all: () => ['org_profile_pictures'] as const,
  },
};
